import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, FormulaIcon, TableIcon, ModulesIcon, UsersIcon, VideoIcon } from '../icons/SalesIcons';
import { SectionDivider } from '../ui/SectionDivider';
export function MechanismSection() {
  const pillars = [{
    icon: FormulaIcon,
    title: 'Fórmulas Exactas',
    description: 'Porcentajes precisos para cada tipo de cera y fragancia'
  }, {
    icon: TableIcon,
    title: 'Tablas de Referencia',
    description: 'Guía de pabilos para nunca equivocarte'
  }, {
    icon: ModulesIcon,
    title: '21 Módulos',
    description: 'Sistema progresivo de cero a profesional'
  }, {
    icon: UsersIcon,
    title: 'Comunidad Privada',
    description: 'Soporte en tiempo real vía WhatsApp y Telegram'
  }, {
    icon: VideoIcon,
    title: '7 Errores Resueltos',
    description: 'Los errores más comunes explicados en video'
  }];
  return <section className="bg-[#2D2926] py-16 md:py-24" data-id="element-287">
      <div className="max-w-6xl mx-auto px-4" data-id="element-288">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-289">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-290">
            <FlameIcon size={40} className="text-[#C4A882]" data-id="element-291" />
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-white mb-6" data-id="element-292">
            El Sistema Que Lo Cambia Todo
          </h2>
          <p className="text-xl text-[#D4A0A0] max-w-3xl mx-auto leading-relaxed" data-id="element-293">
            Después de años fabricando velas artesanales a nivel profesional y
            enseñando a cientos de mujeres, identificamos el{' '}
            <strong className="text-[#C4A882]" data-id="element-294">error raíz</strong> que hace que
            la mayoría fracase:
          </p>
        </motion.div>

        {/* Problem Statement */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-gradient-to-r from-[#9B2335]/20 to-[#9B2335]/10 border border-[#9B2335]/30 rounded-2xl p-8 mb-12 text-center" data-id="element-295">
          <p className="text-2xl md:text-3xl font-heading text-white mb-4" data-id="element-296">
            No hay un puente entre "seguir una receta" y "dominar el oficio."
          </p>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-lg" data-id="element-297">
            <span className="text-[#D4A0A0]" data-id="element-298">
              Las recetas te dicen{' '}
              <strong className="text-white" data-id="element-299">qué hacer</strong>
            </span>
            <span className="hidden md:block text-[#C4A882]" data-id="element-300">vs</span>
            <span className="text-[#D4A0A0]" data-id="element-301">
              El dominio te enseña{' '}
              <strong className="text-[#C4A882]" data-id="element-302">por qué funciona</strong>
            </span>
          </div>
        </motion.div>

        {/* Solution */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-center mb-12" data-id="element-303">
          <p className="text-xl text-white mb-2" data-id="element-304">
            <span className="font-script text-3xl text-[#C4A882]" data-id="element-305">
              ILUMINA Y CREA
            </span>{' '}
            es ese puente.
          </p>
          <p className="text-lg text-[#D4A0A0] max-w-3xl mx-auto" data-id="element-306">
            Es el sistema de 21 módulos que te lleva desde no saber diferenciar
            un tipo de cera hasta crear velas repostería con chantilly, velas
            marmolizadas, wax melts decorativos, velas con flores preservadas y
            mucho más — con la certeza de que cada paso que das está respaldado
            por técnica real, fórmulas exactas y años de experiencia docente.
          </p>
        </motion.div>

        {/* Pillars Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-307">
          {pillars.map((pillar, index) => <motion.div key={pillar.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1 * index
        }} className="bg-gradient-to-br from-[#3D3936] to-[#2D2926] border border-[#C4A882]/30 rounded-xl p-6 text-center group hover:border-[#C4A882] transition-colors duration-300" data-id="element-308">
              <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-[#C4A882] to-[#9B2335] rounded-full flex items-center justify-center" data-id="element-309">
                <pillar.icon size={28} className="text-white" data-id="element-310" />
              </div>
              <h3 className="font-heading text-lg text-white mb-2" data-id="element-311">
                {pillar.title}
              </h3>
              <p className="text-sm text-[#D4A0A0]" data-id="element-312">{pillar.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}